/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Ip_Not_AllowedInputs */

const en_site_url_error_ip_not_allowed = /** @type {(inputs: Site_Url_Error_Ip_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a domain name, not an IP address.`)
};

const id_site_url_error_ip_not_allowed = /** @type {(inputs: Site_Url_Error_Ip_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai nama domain, bukan alamat IP.`)
};

/**
* | output |
* | --- |
* | "Use a domain name, not an IP address." |
*
* @param {Site_Url_Error_Ip_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_ip_not_allowed = /** @type {((inputs?: Site_Url_Error_Ip_Not_AllowedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Ip_Not_AllowedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_ip_not_allowed(inputs)
	return en_site_url_error_ip_not_allowed(inputs)
});